// extracted by mini-css-extract-plugin
module.exports = {"loader":"aXnG8p"};